import { render, staticRenderFns } from "./inputMethodsChart.vue?vue&type=template&id=2ea93202"
import script from "./inputMethodsChart.vue?vue&type=script&lang=js"
export * from "./inputMethodsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports